import { Input, Component, OnInit } from '@angular/core';

import { FrontendModalService } from '@tablesready/frontend-modal';
import {
  ConfirmationCheckboxModalOptions,
  ConfirmationCheckboxModalResponse,
} from './models';

export interface ConfirmationCheckboxModalResult {
  response: ConfirmationCheckboxModalResponse;
  instance: ConfirmationCheckboxModalComponent;
}

@Component({
  selector: 'frontend-confirmation-checkbox-modal',
  templateUrl: './confirmation-checkbox-modal.component.html',
  styleUrls: ['./confirmation-checkbox-modal.component.scss'],
})
export class ConfirmationCheckboxModalComponent implements OnInit {
  @Input() options: ConfirmationCheckboxModalOptions;
  checkboxStatus: boolean;

  constructor(private readonly modalController: FrontendModalService) {}

  ngOnInit(): void {
    this.checkboxStatus = !this.options.showCheckBox;
  }

  confirm(): void {
    this.modalController.dismiss({
      response: { isConfirmed: true, checkboxStatus: this.checkboxStatus },
      instance: this,
    });
  }

  close(): void {
    this.modalController.dismiss({
      response: { isConfirmed: false, checkboxStatus: false },
      instance: this,
    });
  }

  get confirmBtnDisabled(): boolean {
    if (this.options.confirmButtonActiveOnCheckboxSelected) {
      return !this.checkboxStatus;
    }

    return false;
  }
}
